const API_PATHS = {
  FETCH_USER_DETAILS: 'user/me',
  DOCUMENT_DOWNLOAD: 'document/download',
};

export default API_PATHS;
